<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add Param</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Customer Params List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Customer Param Name</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let param of paramData ;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{param.name}}</th>
                    </tr>
                       
                  </tbody>
              </table>
            </div>
   -->


            <div class="personal-details">

              <div class="header-block">
                  <div class="header-title">
                      <p>Customer Params List</p>
                  </div>
                  <div class="add-block">
                    <div class="search">
                      <form autocomplete="off" >
                            <!-- <i class="bi bi-x-lg"></i> -->
                            <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search product" [(ngModel)]="searchKey">
                      </form>
                      <i class="bi bi-x-lg" (click)="refreshSearch()" *ngIf="searchKey != ''"></i>
    
                      <i class="bi bi-search" (click)="getCustomerParamByWildSearch(0,10)"></i>
                    </div>
                      <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                  </div>
              </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                        <th style="width: 80%;">Customer Param Name</th>
                        <th style="width: 20%;">Action</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                <div class="data-view" *ngFor="let param of paramData | paginate : {
                  itemsPerPage: tableSize,
                  currentPage: pageNumber,
                  totalItems: totalRecords
                  }  let i = index">

                    <p style="width: 80%;">{{param.name}}</p>
        
                    <p class="action-buttons" style="width: 20%;padding-left: 15px;">
                      <i *ngIf="actionControls.isModify" (click)="getCustomerParamsById(param.customerParamId)" data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
                      <i *ngIf="actionControls.isDelete" (click)="del(param.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                  </p>
                </div>
              </div>



              <div class="loader" *ngIf="isLoading">
                <div class="spinner"></div>
            </div>

            <div class="loader" *ngIf="!isLoading && paramData.length == 0">
                <div class="no-data">
                    <img src="assets/no-data-6.png" alt="">
                    <p>no data found</p>
                </div>
                
            </div>

            <div class="paginator">
              <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="totalRecords"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
          </div>

          </div>
                  </div>
              </div>
          </div>
  
  
  <div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Customer Param
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="form">
  
            <div class="form-group">
                <label>Customer Param Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addCustomerParam()" class="btn btn-primary">Add Customer Param</button>
      </div>
    </div>
  </div>
  </div>
  </div>


  <div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
            <span data-dismiss="modal">
              <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </span>
          </h5>
        </div>
        <div class="modal-body">
          <p>are you sure? want to delete??</p>
        <div class="modal-footer">
          <button type="button" id="closeModalButton1"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button type="button" (click)="deleteCustomerParam()" class="btn btn-primary">Delete</button>
        </div>
      </div>
    </div>
  </div>
</div>



  
<div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">UPDATE CUSTOMER PARAM
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="editForm">
  
            <div class="form-group">
                <label>Customer Param Name</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton2" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="updateCustomerParams()" class="btn btn-primary">save changes</button>
      </div>
    </div>
  </div>
  </div>
  </div>